import LayoutContainer from "./management/components/LayoutContainer";

import { Typography, Box } from "@material-ui/core";
import settings from "../utils/settings";
const AboutShop = () => {
  const {
    taxId,
    showVat,
    shopName,
    apiVersion,
    isHideProductCode,
    isLiteMode,
    vat,
  } = settings();
  return (
    <LayoutContainer>
      <Box
        style={{
          display: "grid",
          gridTemplateColumns: "50% 50%",
          gap: 10,
          width: "500px",
          margin: "auto",
          marginTop: 100,
          padding: 20,
          backgroundColor: "white",
          borderRadius: 12,
          boxShadow: "10px 10px 5px -6px rgba(0,0,0,0.47)",
          "-webkit-box-shadow": "10px 10px 5px -6px rgba(0,0,0,0.47)",
          "-moz-box-shadow": "10px 10px 5px -6px rgba(0,0,0,0.47)",
        }}
      >
        <Typography>Shop name</Typography>
        <Typography>{shopName}</Typography>
        <Typography>TAX ID</Typography>
        <Typography>{taxId}</Typography>
        <Typography>VAT</Typography>
        <Typography>{vat}</Typography>
        <Typography>VAT included ?</Typography>
        <Typography>{String(showVat)}</Typography>
        <Typography>Lite mode ?</Typography>
        <Typography>{String(isLiteMode)}</Typography>
        <Typography>Hide Product Code</Typography>
        <Typography>{String(isHideProductCode)}</Typography>
        <Typography>API version</Typography>
        <Typography>{apiVersion}</Typography>
      </Box>
    </LayoutContainer>
  );
};

export default AboutShop;
